<template>
  <div class="root">
    <div class="step-progress-container" v-if="processEmployee">
      <ul class="step-progress-bar">
        <li v-for="i in steps" :key="i.id" @click="updateStatus(i.step)">
          <span :class="styleStep(i)"></span>
          <p>{{ i.name }}</p>
          <div
            v-if="
              processEmployee.proce_state.id &&
              processEmployee.proce_state.id == i.step &&
              processEmployee.proce_state.id != 8
            "
            class="desc"
          >
            <div class="arrow"></div>
            <span class="icon-alert mr-3"></span>
            <p v-if="timeCalculate > 0">Quedan {{ timeCalculate }} días</p>
            <p v-if="timeCalculate == 0">Es hoy... ES HOY!</p>
            <p v-if="timeCalculate < 0">Vencido</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "StepProgress",
  props: {
    processEmployee: {
      type: Object,
      required: true,
    },
    dateKnowledge: {
      type: String,
      required: true,
    },
  },
  created() {
    if (this.processEmployee.proce_state.id > 4) {
      this.steps[4].step = this.processEmployee.proce_state.id;
      this.steps[4].name = this.processEmployee.proce_state.name;
    }
  },
  updated() {
    if (this.processEmployee.proce_state.id > 4) {
      this.steps[4].step = this.processEmployee.proce_state.id;
      this.steps[4].name = this.processEmployee.proce_state.name;
    }
  },
  data() {
    return {
      steps: [
        {
          step: -1,
          name: "Reporte",
          icon: "icon-lupa-2",
        },
        {
          step: 1,
          name: "Citación",
          icon: "icon-hojasincheck",
        },
        {
          step: 2,
          name: "Diligencia",
          icon: "icon-diligencia",
        },
        {
          step: 3,
          name: "Sanción",
          icon: "icon-info",
        },
        {
          step: 4,
          name: "Recursos",
          icon: "icon-revision",
        },
      ],
    };
  },
  computed: {
    ...mapState("modProcessEmployee", ["process"]),
    timeCalculate() {
      let time = 0;
      if (this.processEmployee.proce_state.id == 1) {
        let date = new Date(this.dateKnowledge);
        //date.setDate(date.getDate() + this.processEmployee.proce_state.days);
        date.setDate(date.getDate() + this.process.daysLimitState);
        let dif = date - new Date();
        time = Math.round(dif / (1000 * 60 * 60 * 24));
      }
      if (this.processEmployee.proce_state.id > 1) {
        let date = new Date(
          this.processEmployee.proce_citations[
            this.processEmployee.proce_citations.length - 1
          ].date
        );
        //date.setDate(date.getDate() + this.processEmployee.proce_state.days);
        date.setDate(date.getDate() + this.process.daysLimitState);
        let dif = date - new Date();
        time = Math.round(dif / (1000 * 60 * 60 * 24));
      }
      return time;
    },
  },
  methods: {
    ...mapMutations("modProcessEmployee", ["setStatus"]),
    updateStatus(status) {
      if (status > 0) {
        if (status <= this.processEmployee.proce_state.id) {
          this.setStatus(status);
        }
      } else {
        this.$router.push(
          "/processDetail/" + this.processEmployee.proce_report_id
        );
      }
    },
    styleStep(step) {
      if (this.processEmployee.proce_state.id) {
        return [
          step.icon,
          {
            active: this.processEmployee.proce_state.id >= step.step,
            actual:
              this.processEmployee.proce_state.id == step.step &&
              this.processEmployee.proce_state.id != 8,
            actualView: this.process.status == step.step,
          },
        ];
      }
      return {};
    },
  },
};
</script>


<style scoped>
.step-progress-container {
  width: 100%;
  z-index: 1;
  margin-top: 20px;
}

.step-progress-bar li {
  float: left;
  width: 18%;
  position: relative;
  text-align: center;
  cursor: pointer;
}

.step-progress-bar li > span:before {
  width: 40px;
  height: 40px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 15px auto;
  border-radius: 50%;
  line-height: 35px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}

.step-progress-bar li > span.actualView:before {
  width: 56px;
  height: 56px;
  margin: -10px auto 9px auto;
  line-height: 50px;
}

.step-progress-bar li > span:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 8px;
  background: #979797;
  top: 16px;
  left: -50%;
  z-index: -1;
}

.step-progress-bar li > span.active:before {
  border-color: #779b49;
  color: #779b49;
}

.step-progress-bar li > span.actual:before {
  border-color: #e48d3d;
  color: #e48d3d;
}

.step-progress-bar li > span.active:after {
  background: #779b49;
}

.step-progress-bar li:first-child span:after {
  content: none;
}

.step-progress-bar li .desc {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 161px;
  height: 38px;
  left: 50%;
  transform: translate(-50%, 0);
  background: transparent;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  z-index: 1;
  margin-top: 5px;
}

.step-progress-bar li .desc::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
}

.step-progress-bar li .desc p {
  color: #d64545;
  margin: 0;
  z-index: 1;
}

.step-progress-bar li .desc span {
  color: #d64545;
  z-index: 1;
}

.step-progress-bar li .desc .arrow {
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  border: 0;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  background: #fff;
  transform: rotate(45deg);
  z-index: -1;
  top: -8px;
  left: calc(50% - 8px);
}
</style>